import React from 'react';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import { renderRoutes } from 'react-router-config';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import routes from './routes.js';
import './styles/global.scss';
import store from './data/store';
import { history } from './data/store';
import { isRunningOnClientSide, isSupportedBrowser } from './utils/func';
import NoSupportedBrowser from './components/noSupportBrowser/NoSupportBrowser';
const TYPE_APP = process.env.NODE_APP_TYPE;
const IS_CLIENT_SIDE = isRunningOnClientSide();
const IS_SUPPORT_BROWSER = isSupportedBrowser();

if(process.env.BUGSNAG_API_KEY && process.env.BUGSNAG_API_KEY != '') {
    Bugsnag.start({
        apiKey: process.env.BUGSNAG_API_KEY,
        plugins: [new BugsnagPluginReact()]
    })

    var ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React)
}

/***********************************************************************************************************************
 *
 * @type {React.NamedExoticComponent<object>}
 *********************************************************************************************************************/
const Main = React.memo( () => {
    return process.env.BUGSNAG_API_KEY && process.env.BUGSNAG_API_KEY != '' ? (
        <ErrorBoundary>
            <Provider store={ store }>
                { ( TYPE_APP !== 'ssr' ) ?
                    <HashRouter history={ history }>
                        { renderRoutes( routes ) }
                    </HashRouter>
                    :
                    <BrowserRouter history={ history }>
                        { renderRoutes( routes ) }
                    </BrowserRouter>
                }
            </Provider>
        </ErrorBoundary>
    ) : (
        <Provider store={ store }>
            { ( TYPE_APP !== 'ssr' ) ?
                <HashRouter history={ history }>
                    { renderRoutes( routes ) }
                </HashRouter>
                :
                <BrowserRouter history={ history }>
                    { renderRoutes( routes ) }
                </BrowserRouter>
            }
        </Provider>
    );
} );


if ( IS_CLIENT_SIDE ) {
    const root = ReactDOM.createRoot( document.getElementById( 'mount' ) );

    IS_SUPPORT_BROWSER ? root.render(  <Main/> ) :  root.render(  <NoSupportedBrowser/> ) ;
}

// if ( IS_CLIENT_SIDE ) {
//     IS_SUPPORT_BROWSER ? ReactDOM.render(  <Main/> , document.getElementById( 'mount' ) ) :  ReactDOM.render(  <NoSupportedBrowser/>, document.getElementById( 'mount' ) ) ;
// }
